<mat-toolbar color="primary">
  <span>{{ "Angre siste beholdningsoppdatering" | translate }}</span>
  <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <h2>Angre siste beholdningsoppdatering</h2>
  @if (serverResponderteMedValideringsfeil()){
    <div class="valideringsfeil" @fadeInn id="assbd-valideringsfeil" >
      <inline-melding type="advarsel">
        <div translate>Angring av siste beholdningsoppdatering feilet da beholdning har blitt oppdatert av annen bruker.</div>
        <div translate>Beholdningsinformasjon har blir lastet på nytt, vennligst prøv på nytt.</div>
      </inline-melding>
    </div>
  }
  @if(slettInfoModell() != null){
    <article>
      <div>{{ "Den forrige oppdateringen av aksjeeierboken med innføringsdato {sisteInnfoeringsdato} slettes." | translate: {sisteInnfoeringsdato: slettInfoModell()?.sisteInnfoeringsdato } }}</div>
      <div>{{ "Aksjeeierboken blir som følger." | translate }}</div>
    </article>
    <aksjeeiere-slett-siste-beholdningsendring [slettInfoModell]="slettInfoModell()"></aksjeeiere-slett-siste-beholdningsendring>
  } @else {
    <laster-data>
      {{ "Henter aksjeeierboken..." | translate }}
    </laster-data>
  }
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
  <button mat-raised-button color="warn" (click)="utfoerSlett()" cdkFocusInitial [visSpinner]="lagrer()" data-testid="utfør-slett">{{ "Angre siste oppdatering" | translate }}</button>
</mat-dialog-actions>
